import { ENTERED_WIZARD } from '../../../common/redux/actions/types/SelectionCriteriaWizardActionTypes';
import {
  ALL_TRANSPORT_MODES_DE_SELECTED,
  ALL_TRANSPORT_MODES_SELECTED,
  TRANSPORT_MODE_SELECTED,
} from '../actions/types/TransportModeActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';

const initialState = {
  selected: [],
};

export default function transportModeReducer(state = initialState, action, allNodes) {
  switch (action.type) {
    case TRANSPORT_MODE_SELECTED:
      return { ...state, selected: action.selected };
    case ALL_TRANSPORT_MODES_SELECTED:
      return { ...state, selected: allNodes };
    case ALL_TRANSPORT_MODES_DE_SELECTED:
      return { ...state, selected: [] };
    case ENTERED_WIZARD:
      return initialState;
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
}

